const names =
    [
        {id: 1, name: 'Traffic'},
        {id: 8, name: 'Environment'},
        {id: 13, name: 'Business'},
        {id: 14, name: 'Public security'},
        {id: 16, name: 'Architecture'},
        {id: 22, name: 'Spatial'},
        {id: 30, name: 'Temporal'},
        {id: 35, name: 'Other property'},
        {id: 45, name: 'Learning-based'},
        {id: 51, name: 'Statistical'},
        {id: 58, name: 'Rule-based'},
    ]



export default names;